import {createRouter, createWebHistory} from "vue-router";
import routes from "./routes";
import oneRater from "@/stores/onerater";
import middlewarePipeline from './middleware/middlewarePipeline';

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return {x: 0, y: 0};
        }
    },
});


router.beforeEach(async (to, from, next) => {
    const store = oneRater()
    if (from.name === 'insurance.final' && (to.name === 'insurance.applicant' || to.name === 'insurance.payment')) {
        store.CLEAR_STATE()
    }

    if (from.name === 'renew.final' && (to.name === 'renew.overview' || to.name === 'renew.stripe')) {
        store.CLEAR_FORM_DATA()
    }

    if (!to.meta.middleware) {
        return next();
    }

    const middleware = to.meta.middleware;

    const context = {
        to,
        from,
        next,
        store,
    };
    return middleware[0]({
        ...context,
        nextMiddleware: middlewarePipeline(context, middleware, 1),
    });
});

export default router;
